module.exports = __webpack_public_path__ + "img/mingxia.c321c5a7.jpeg";